import { render, staticRenderFns } from "./DetailTNASocial.vue?vue&type=template&id=2ccf8b81"
import script from "./DetailTNASocial.vue?vue&type=script&lang=js"
export * from "./DetailTNASocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports